import * as types from '../actions/quartzActions';
import * as commonTypes from '../actions/commonActions';

const initialState = {
    environments: [],
    serverValues: [],
    enums: {},
    loaded: false,
    loading: true,
    expandedJob: [],
    changes: {
        addedTriggers: 0,
        editedTriggers: 0,
        deletedTriggers: 0,
        triggerChanges: [],
        jobChanges: [],
    },
    activeKey: 0,
    infoMessage: ""
};

export default function systemReducer(state = initialState, action) {
    switch (action.type) {
        case types.INITIALIZE:
            var serverValues = JSON.parse(JSON.stringify(action.data.environments));
            return {
                ...state,
                environments: action.data.environments,
                serverValues: serverValues,
                enums: action.data.enums,
                loaded: true,
                loading: false,
                changes: {
                    addedTriggers: 0,
                    editedTriggers: 0,
                    deletedTriggers: 0,
                    triggerChanges: [],
                    jobChanges: []
                }
            };
        case types.SET_EXPANDED_JOBS:
            const { expandedJob } = state;
            const getExpandedJob = () => {
                if (expandedJob.includes(action.key)) {
                    return expandedJob.filter(x => x !== action.key);
                }

                const newJobs = [...expandedJob];
                newJobs.push(action.key)
                return newJobs;
            }

            const ejobs = getExpandedJob();
            return {
                ...state,
                expandedJob: ejobs
            };
        case types.SET_TRIGGERS_CHANGES:
            return {
                ...state,
                changes: action.changes
            };
        case types.SAVE:
            if (action.data.ok === true) {
                var changes = {
                    addedTriggers: 0,
                    editedTriggers: 0,
                    deletedTriggers: 0,
                    triggerChanges: [],
                    jobChanges: []
                };
                var envs = JSON.parse(JSON.stringify(state.environments));
                for (var i = 0; i < envs.length; i++) {
                    var env = envs[i];
                    for (var j = 0; j < env.jobs.length; j++) {
                        var job = env.jobs[j];
                        for (var x = 0; x < job.triggers.length; x++) {
                            var trigger = job.triggers[x];
                            trigger.isEdited = false;
                            trigger.isDeleted = false;
                            trigger.isNew = false;
                            if (trigger.jobType === "SystemJob") {
                                trigger.tenant = "";
                            }
                        }
                    }
                }
                var envsServer = JSON.parse(JSON.stringify(envs));
                var infoMessage = '<span>Quartz configuration was successfully saved and reseted.</span></br></br>' + action.data.fileHtml;
                return {
                    ...state,
                    changes: changes,
                    environments: envs,
                    serverValues: envsServer,
                    infoMessage: infoMessage,
                    loading: false
                };
            }
            else {
                return {
                    ...state,
                    loading: false,
                    infoMessage: action.data.error
                };
            }
        case types.DISCARD:
            return {
                ...state,
                changes: action.obj.changes,
                environments: action.obj.env
            };
        case types.SET_ACTIVE_KEY:
            return {
                ...state,
                activeKey: action.key
            };
        case types.SET_JOB:
            return setJob(state, action);
        case types.HANDLE_TRIGGER_CHANGE:
            return updateChangesBuffer(state, action);
        case types.LOADING:
            return {
                ...state,
                loading: action.value
            };
        case types.SET_MESSAGE:
            return {
                ...state,
                infoMessage: action.message
            };
        case types.DISCARD_ALL_CHANGES:
            var values = JSON.parse(JSON.stringify(state.serverValues));
            var changes = {
                addedTriggers: 0,
                editedTriggers: 0,
                deletedTriggers: 0,
                triggerChanges: [],
                jobChanges: []
            };
            return {
                ...state,
                changes: changes,
                environments: values
            };
        default:
            return state;
    }
}

function setJob(state, action) {
    const {
        job: newJob,
        envName,
    } = action.payload;

    const envs = state.environments;
    const envIdx = envs.findIndex(x => x.environmentName === envName);
    if (envIdx === -1) {
        return state;
    }

    const env = envs[envIdx];
    if (!env || !env.jobs) {
        return state;
    }

    const newEnvironments = JSON.parse(JSON.stringify(envs));
    const newEnv = newEnvironments[envIdx];
    const newJobs = newEnv.jobs;
    const jobIndex = newJobs.findIndex(x => x.jobName === newJob.jobName);
    if (jobIndex > -1) {
        newJobs[jobIndex] = newJob;
    } else {
        newJobs.push(newJob);
    }

    return {
        ...state,
        environments: newEnvironments,
    };
}

function updateChangesBuffer(state, action) {
    const { trigger, type, triggers } = action.obj;
    const changesBuf = JSON.parse(JSON.stringify(state.changes));

    switch (type) {
        case 0: //  add
            pushTriggerToBuff(trigger);
            changesBuf.addedTriggers += 1;
            break;
        case 1: // delete
            changesBuf.addedTriggers -= removeNewItemsFromBuff();
            changesBuf.deletedTriggers += removeNotNewItemsFromBuff();
            break;
        case 2: // edit
            if (!action.obj.isEdited) {
                changesBuf.editedTriggers += 1;
            }
            pushTriggerToBuff(trigger);
            break;
        default:
            break;
    }

    return {
        ...state,
        changes: changesBuf,
    };

    function removeNotNewItemsFromBuff() {
        const toRemove = triggers.filter(x => x.isNew !== true && x.isSelected === true);
        const removedCount = toRemove.length;

        for (let i = 0; i < removedCount; i++) {
            const _trigger = toRemove[i];

            const changeIndex = changesBuf.triggerChanges.findIndex(x => x.id === _trigger.id);
            if (changeIndex !== -1) {
                changesBuf.triggerChanges[changeIndex].type = 1;
                changesBuf.editedTriggers -= 1;
            } else {
                pushTriggerToBuff(_trigger);
            }
        }

        return removedCount;
    }

    function removeNewItemsFromBuff() {
        const toRemove = triggers.filter(x => x.isNew === true && x.isSelected === true);
        const removedCount = toRemove.length;

        for (let i = 0; i < removedCount; i++) {
            const _trigger = toRemove[i];

            const changeIndex = changesBuf.triggerChanges.findIndex(x => x.id === _trigger.id);
            if (changeIndex !== -1) {
                changesBuf.triggerChanges
                    .splice(changeIndex, 1);
            }
        }

        return removedCount;
    }

    function pushTriggerToBuff(trigger) {
        changesBuf
            .triggerChanges
            .push({
                type: type,
                id: trigger.id,
                env: trigger.environment,
                job: trigger.jobName,
            });
    }
}